import PropTypes from 'prop-types';
import React from 'react';

const IconAreaManagement = ({ className }) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      height="30"
      viewBox="0 0 30 30"
      width="30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6248 5.4482V21.0295L5.22519 24.8275C4.64054 25.2385 3.84837 24.8691 3.75719 24.1911L3.74854 24.0605V10.7699C3.74854 10.5082 3.85773 10.2606 4.04619 10.0847L4.14688 10.0029L10.6248 5.4482ZM26.2428 5.81048L26.2515 5.94109V19.2318C26.2515 19.4934 26.1423 19.741 25.9538 19.917L25.8531 19.9987L19.3748 24.5507V8.9682L24.7748 5.17413C25.3594 4.76314 26.1516 5.13255 26.2428 5.81048ZM12.4998 5.44945L17.4998 8.96445V24.5482L12.4998 21.0307V5.44945Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconAreaManagement;

IconAreaManagement.propTypes = {
  className: PropTypes.string,
};
